/**
 * Beaucoup d'options courtes — la liste fermée des dix classes du sous-scénario
 * « affirmer sa classe » — se rendent en grille de pastilles plutôt qu'en lignes
 * de 60 px empilées, illisibles dans la bulle de Sam.
 *
 * Le seuil vaut pour ce qu'il décrit : des libellés courts, en nombre. Un choix à
 * 2-3 options en phrases garde ses lignes, qui se lisent mieux, et une option
 * portant une `action` (date, saisie libre, photo) n'est jamais une pastille.
 *
 * Aujourd'hui une seule liste du service IA dépasse cinq options — celle-ci ;
 * toutes les autres sont plafonnées à 2-5 par prompt, schéma ou `limit(5)`. La
 * marge est donc mince des deux côtés : le tour de confirmation à deux options
 * (« Oui » / « J'ai changé de classe ») n'est tenu à l'écart que par le `>= 6`, et un
 * futur libellé de 17 caractères ferait retomber la liste en lignes. Le test
 * jumeau épingle les deux bords.
 */
export const COMPACT_MIN_OPTIONS = 6
export const COMPACT_MAX_LABEL_LENGTH = 16

export const isCompactChoice = (options) =>
    Array.isArray(options) &&
    options.length >= COMPACT_MIN_OPTIONS &&
    options.every(
        (o) => !o?.action && (o?.body?.length ?? 0) <= COMPACT_MAX_LABEL_LENGTH
    )
